<script>
  import router from '../lib/router';
  import UnauthenticatedLayout from '../app-shell/guest-app/Layout.svelte';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import Messages from '../lib/components/Messages.svelte';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import { show_message } from '../lib/flash.ts';
  import APIClient from '../state-charts/api-client';
  import * as R from 'ramda';
  import Validators from '../lib/validators';

  // component options  ------------------------------------------------------ //

  export let query = null;

  // internal variables ------------------------------------------------------ //

  let new_password;
  let new_password_confirm;

  let validators = {
    new_password: true,
    new_password_confirm: true
  }

  let input_errors = {
    new_password: null,
    new_password_confirm: null,
  }

  let change_password_disabled = true;

  // translated strings ------------------------------------------------------ //

  let reset_password_title = t9n(TS.RESET_PASSWORD_FORM_TITLE);
  let reset_password_label = t9n(TS.RESET_PASSWORD_SUBMIT_LABEL);
  let password_label = t9n(TS.RESET_PASSWORD_PASSWORD_LABEL);
  let confirm_password_label = t9n(TS.RESET_PASSWORD_CONFIRM_PASSWORD_LABEL);
  let login_label = t9n(TS.RESET_PASSWORD_CANCEL_LABEL);
  let no_token_message = t9n(TS.RESET_PASSWORD_NO_TOKEN_MESSAGE);
  let success_message = t9n(TS.RESET_PASSWORD_SUCCESS_MESSAGE);

  const to_login = () => {
    router.navigate('/login');
  };

  const reset_form_state = () => {
    new_password = null;
    new_password_confirm = null;
    change_password_disabled = true;
  };


  const reset_password = async () => {
    if (!query || !query.reset_token) {
      show_message(no_token_message, 'error');
    }

    const data = {
      password: new_password,
      password_confirm: new_password_confirm,
      reset_token: query.reset_token,
    };

    reset_form_state();
    const result = await APIClient.reset_password(data);

    if (!!result) {
      router.navigate('/login');
      show_message(success_message, 'success');
    }
  };

  const validate_new_password = (pw, pw_confirm) => {
    let result = Validators.validate_password(pw, pw_confirm);
    validators.password = result.valid;
    input_errors.new_password = result.error;
  };

  const validate_new_password_confirm = (pw_confirm, pw) => {
    let result = Validators.validate_password(pw_confirm, pw);
    validators.new_password_confirm = result.valid;
    input_errors.new_password_confirm = result.error;
  };

  const check_filled = () => {
    const TRUE = R.equals(true);
    const checks = [
      !!new_password && validators.new_password,
      !!new_password_confirm && validators.new_password_confirm,
    ];

    return R.all(TRUE)(checks);
  };

  $: {
    new_password;
    new_password_confirm;

    setTimeout(() => {
      change_password_disabled = !check_filled();
    }, 500);
  }

  $: if(!!new_password && new_password.length > 0) validate_new_password(new_password, new_password_confirm);
  $: if(!!new_password_confirm && new_password_confirm.length > 0) validate_new_password_confirm(new_password_confirm, new_password);
</script>

<UnauthenticatedLayout>
  <div id="reset-password-page" slot="content" class="container">
    <main class="contained-section">
      <!-- Logo -->
      <img src="/assets/login-logo.png" alt="" class="logo fade-in" />

      <section class="main-intro">

        <div class="reset-password-container">
          <h1 class="mdc-typography--headline5">{reset_password_title}</h1>

          <div class="margin-space" />

          <!-- Password field -->
          <div class='input-width'>
            <InputWithValidation
              id="password"
              type="password"
              label={password_label}
              leading_icon="security"
              trailing_icon="password"
              name="password"
              bind:value={new_password}
              valid={validators.new_password}
              validation_text={input_errors.new_password}
              width='350px'/>
          </div>


          <!-- Password confirmation field -->
          <div class='input-width'>
          <InputWithValidation
            id="password-confirm"
            type="password"
            label={confirm_password_label}
            leading_icon="security"
            trailing_icon="password_confirm"
            name="password_confirm"
            bind:value={new_password_confirm}
            valid={validators.new_password_confirm}
            validation_text={input_errors.new_password_confirm}
            width='350px'/>
          </div>

          <!-- Reset password button -->
          <div class="action-container">
            <button
              data-cy="reset-password"
              class="mdc-button mdc-button--raised"
              disabled={!!change_password_disabled}
              on:click|preventDefault={async () => { await reset_password() } }>
              {reset_password_label}
            </button>
          </div>

          <!-- Login link -->
          <div class="login-link-align">
            <button
              id="to-login"
              class="mdc-button mdc-dialog__button"
              on:click|stopPropagation|preventDefault={to_login}>
              <span class="mdc-button__label">{login_label}</span>
            </button>
          </div>

        </div>
      </section>

      <!-- Confirm message -->
      <Messages />
    </main>
  </div>
</UnauthenticatedLayout>

<style type="text/scss">
  /* Define theme variables before importing any MDC Web component styles */
  #reset-password-page {
    background-image: url('/assets/orderer_background1.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-size: cover;
  }

  :root {
    --pageMax: 1024px;
  }

  /* Base */
  .container {
    justify-content: center;
    align-items: center;
    min-height: 100%;
    width: 100vw;
    margin: 0;
    padding-bottom: 1em;
  }

  .contained-section {
    max-width: var(--pageMax);
    padding: 16px;
    width: calc(100vw - 32px);
    margin: 0 auto;
  }

  .main-intro {
    /*width: calc(100% - 150px);*/
  }

  .margin-space {
    margin-top: 50px;
  }

  .logo {
    width: 114px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: -50px;
  }

  .reset-password-container {
    margin: auto;
    /*width: 50%;*/
    max-width: 350px;
    text-align: center;
    padding: 32px;
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    margin-top: 50px;
  }

  .action-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }

  .login-link-align {
    margin-top: 20px;
    text-align: right;
  }

  /* Mobile Mode
  *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .contained-section {
      padding: 10px;
      width: calc(100vw - 27px);
      margin: 0;
    }

    .main-intro {
      display: flex;
    }
  }
</style>
